import { useNavigate } from 'react-router-dom';
import '../../styles/participant.css';
import { ParticipantShell, SessionDashboard } from '../../features/sessions-participant';

export default function ParticipantDashboard() {
  const navigate = useNavigate();

  return (
    <ParticipantShell pageTitle="Sessions">
      <SessionDashboard onOpenSession={id => navigate(`/sessions/${id}`)} />
    </ParticipantShell>
  );
}
